module.exports = __webpack_public_path__ + "img/Mozambique.aa05faa4.png";